import { Routes } from '@/assets/configs'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import useCurrentUser from '@/hooks/useCurrentUser'

export const useCanDeleteAccount = () => {
  const router = useRouter()
  const { settings } = useCurrentUser()
  const canDeleteAccount = useMemo(() => !settings?.subscriptionStatus?.isAutoRenewalActive, [settings])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  useEffect(() => {
    if (canDeleteAccount) {
      setIsLoaded(true)
      return
    }
    router.push(Routes.MyAccount.settings)
  }, [canDeleteAccount])

  return { canDeleteAccount, isLoaded }
}
